var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.005,
    height: 119.657,
    viewBox: "0 0 92.005 119.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815",
    transform: "translate(-5428.85 -7802.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Water_4365945_1_",
    "data-name": "noun_Water_4365945 (1)",
    transform: "translate(5413.12 7796.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8",
    transform: "translate(15.88 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M55.48,22.426a2.758,2.758,0,0,0-.439-1.517,2.62,2.62,0,0,0-2.194-1.178c-1.254,0-2.206,0-8.386,8.775-3.761,5.39-8,11.984-11.846,18.54C24.981,60.071,15.88,77.722,15.88,88.264a37.093,37.093,0,0,0,74.187,0c0-9.966-8.073-20.4-16.61-31.427C64.619,45.417,55.48,33.608,55.48,22.426Zm-2.507,97.917A32.117,32.117,0,0,1,20.894,88.264c0-14.391,21.587-48.965,30.086-60.335C53.224,38.861,61.472,49.541,69.5,59.908S85.052,79.965,85.052,88.264A32.117,32.117,0,0,1,52.973,120.343Zm1.479-14.216a2.507,2.507,0,0,1-2.507,2.507A21.11,21.11,0,0,1,30.86,87.55a2.507,2.507,0,1,1,5.014,0A16.083,16.083,0,0,0,51.945,103.62,2.507,2.507,0,0,1,54.452,106.128Z",
    transform: "translate(-15.88 0)",
    fill: "#0077b6",
    stroke: "#0077b6",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Water_4365945_1_2",
    "data-name": "noun_Water_4365945 (1)",
    transform: "translate(5461.161 7802.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8-2",
    "data-name": "Layer 8",
    transform: "translate(24.507 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117-2",
    "data-name": "Path 117",
    d: "M52.062,16.562c-3.629-4.685-7.39-9.568-7.39-13.843a2.705,2.705,0,0,0-.8-1.9A2.639,2.639,0,0,0,41.98,0C40.963,0,39.34,0,31.924,12.524,28.545,18.277,24.507,26.169,24.507,31a17.525,17.525,0,0,0,35.037,0C59.544,26.209,55.915,21.524,52.062,16.562Zm-10.029,26.7A12.247,12.247,0,0,1,29.786,31.025c0-4.777,6.73-16.311,10.848-22.434,1.584,3.88,4.46,7.575,7.258,11.2,3.128,4.038,6.374,8.222,6.374,11.23A12.247,12.247,0,0,1,42.032,43.259Zm4.421-5.727a2.639,2.639,0,0,1-2.639,2.639A10.637,10.637,0,0,1,33.257,29.613a2.639,2.639,0,1,1,5.279,0,5.279,5.279,0,0,0,5.279,5.345,2.639,2.639,0,0,1,2.639,2.573Z",
    transform: "translate(-24.507 0)",
    fill: "#f28d18",
    stroke: "#f28d18",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water_drop.0a86332b836285918e812b924e82e1af.svg";
export { ForwardRef as ReactComponent };